import { useContext, useEffect, useState } from 'react';
import CompoundMetricsContext from '../../../../contexts/CompoundMetricsContext';
import metricTypeCheckers from '../../../../types/metricTypeCheckers';
import { SAVED_FILTER_RESOURCE } from '../../../../constants';

const useMetricSources = (metric?: Metrics.NormalMetric) => {
  const [sources, setSources] = useState<Timeline.EventSource[]>([]);
  useEffect(() => {
    if (!metric) {
      setSources([]);
      return;
    }

    const savedFilterSources: Timeline.EventSource[] =
      metric.datasetFilterIds?.map((dfid) => ({
        id: dfid,
        type: SAVED_FILTER_RESOURCE,
      })) || window.emptyArray;

    setSources([
      {
        type: 'Metric',
        id: metric.id,
      },
      ...savedFilterSources,
    ]);
  }, [metric]);

  return sources;
};

const useCompoundSources = (metric?: Metrics.CompoundMetric) => {
  const { compoundMetricInputsLookup } = useContext(CompoundMetricsContext);
  const [sources, setSources] = useState<Timeline.EventSource[]>([]);
  useEffect(() => {
    if (!metric) {
      setSources([]);
      return;
    }

    const inputs = compoundMetricInputsLookup[metric.id];
    const newSources: Timeline.EventSource[] = [
      {
        type: 'CompoundMetric',
        id: metric.id,
      },
    ];
    if (inputs) {
      inputs.forEach((m) => {
        newSources.push({
          type: 'Metric',
          id: m.id,
        });
      });
    }

    setSources(newSources);
  }, [compoundMetricInputsLookup, metric]);

  return sources;
};

const useMetricTimelineSources = (
  metric: Metrics.NormalMetric | Metrics.CompoundMetric | undefined,
) => {
  const normal = useMetricSources(
    metricTypeCheckers.isNormalMetric(metric) ? metric : undefined,
  );
  const compound = useCompoundSources(
    metricTypeCheckers.isCompoundMetric(metric) ? metric : undefined,
  );

  if (metricTypeCheckers.isNormalMetric(metric)) {
    return normal;
  }

  return compound;
};

export default useMetricTimelineSources;
